import { render, staticRenderFns } from "./shipData.vue?vue&type=template&id=8f5eafe4&scoped=true&"
import script from "./shipData.vue?vue&type=script&lang=js&"
export * from "./shipData.vue?vue&type=script&lang=js&"
import style0 from "./shipData.vue?vue&type=style&index=0&id=8f5eafe4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f5eafe4",
  null
  
)

export default component.exports